/* eslint-disable no-unused-vars */
enum TableSelection {
    TOTAL = 'Total',
    A_SIDES = 'A-Sides',
    COLLECTIBLES = 'Collectibles',
    B_SIDES = 'B-Sides',
    C_SIDES = 'C-Sides',
}

export default TableSelection
